import React from 'react';
import { filter, noop } from 'lodash-es';
import { Dropdown } from '@fuxi/eevee-ui';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames/bind';
import { MonorepoType, SubPackageSlugEnum, checkIsYaotaiUser, useLoginInfo } from '@yaotai/common-utils';
import { useParams } from 'react-router-dom';
import { encodeNextUrl } from '../../utils';
import { ysfClose } from '../../utils/ysf.js';
import { Avatar } from '../../components';

import { getCorporateUrl, useInvokeAreaPrefix, useUserInfo } from '../../hooks';
import { YAOTAI_DEFAULT_AVATAR } from '../../constants/common';
import { useYaotaiGlobalContextState } from '../../contexts';
import { USER_CENTER_URL } from '../../constants';
import styles from './style.module.less';

const cx = classnames.bind(styles);

export const PCHeaderDropAvatar = ({
  isActivityHomePage = false,
  type = 'center',
  isMainVersion = true,
  overlayMinWidth = '52px',
  extraInfo = {
    isSystemOrOrganizer: false,
    showCloseActivity: false,
  },
  extraUtils = {
    handleShutdownModalVisible: noop,
  },
}: {
  extraInfo?: {
    isSystemOrOrganizer?: boolean;
    showCloseActivity?: boolean;
  };
  extraUtils?: {
    handleShutdownModalVisible?: Function;
  };
  isActivityHomePage?: boolean;
  isMainVersion?: boolean;
  isSystemOrOrganizer?: boolean;
  overlayMinWidth?: string;
  type?: MonorepoType;
}) => {
  const { t } = useTranslation();
  const { handleLogOut, rbacUserInfo } = useLoginInfo();
  const { login_type } = useUserInfo();
  const { spaceAuth, oem, currentAid } = useYaotaiGlobalContextState();
  const { hasSpacePermission } = spaceAuth;
  const { sid } = useParams();
  const { login } = useInvokeAreaPrefix();

  const allMenuItems = [
    {
      key: 'activity',
      label: <span>{t('navHeader.userMenu.1')}</span>,
      visible: checkIsYaotaiUser(login_type) && (!!oem?.oem_my_act?.status || !currentAid),
      onClick: () => (window.location.href = `/${SubPackageSlugEnum.Center}/user`),
    },
    {
      key: 'info',
      label: <span>{t('navHeader.userMenu.0')}</span>,
      visible: checkIsYaotaiUser(login_type) && (!!oem?.oem_self_info?.status || !currentAid),
      onClick: () => (window.location.href = USER_CENTER_URL),
    },
    {
      key: 'space',
      visible: ['portal'].includes(type) && checkIsYaotaiUser(login_type) && hasSpacePermission,
      label: <span>{t('navHeader.userMenu.3')}</span>,
      onClick: () => (window.location.href = getCorporateUrl()),
    },
    {
      key: 'close-activity',
      visible: ['reception'].includes(type) && (extraInfo?.showCloseActivity || false),
      label: <span>关闭活动</span>,
      onClick: () => extraUtils?.handleShutdownModalVisible?.(),
    },
    {
      key: 'survey',
      visible:
        ['reception'].includes(type) && (extraInfo?.isSystemOrOrganizer || false) && oem?.oem_admin_feedback?.status,
      label: <span>使用反馈</span>,
      onClick: () => window.open('https://survey.dingwei.netease.com/htmls/yaotai/paper.html'),
    },
    {
      key: 'logout',
      visible: true,
      label: <span>{t('navHeader.userMenu.2')}</span>,
      // eslint-disable-next-line react-func/max-lines-per-function
      onClick: () => {
        handleLogOut();
        ysfClose();
        // 官网登出跳回官网首页
        if (type === 'portal') {
          window.location.href = `/`;
          return;
        }
        if (isActivityHomePage || ['corporate'].includes(type)) {
          window.location.href = `/${SubPackageSlugEnum.Center}${login}?next=${encodeNextUrl(window.location.href)}`;
          return;
        }
        if (['corporate'].includes(type)) {
          window.location.href = `/${SubPackageSlugEnum.Corporate}/${sid}/login?next=${encodeNextUrl(
            window.location.href,
          )}`;
          return;
        }
        if (!checkIsYaotaiUser(login_type)) {
          window.location.href = `/${SubPackageSlugEnum.Center}${login}`;
        } else {
          window.location.href = `/${SubPackageSlugEnum.Center}${login}?next=${encodeNextUrl(
            window.location.href.split('?')[0],
          )}`;
        }
      },
    },
  ];

  return (
    <div className={cx('menu-wrapper', type)}>
      <Dropdown
        overlayClassName={cx('menu')}
        menu={{
          className: cx('logout'),
          items: filter(allMenuItems, item => item.visible),
        }}
        overlayStyle={{ minWidth: overlayMinWidth }}
        getPopupContainer={triggerNode => triggerNode.parentElement!}>
        <div className={cx('user-info')}>
          <Avatar className={cx('user-avatar')} size={30} img={YAOTAI_DEFAULT_AVATAR} />
        </div>
      </Dropdown>
    </div>
  );
};
